export const QUEST_DETAILS_TAB_ID = "QuestChange-Details";
export const QUEST_APPROVERS_TAB_ID = "QuestChange-Approvers";
export const QUEST_ATTACHMENTS_TAB_ID = "QuestChange-Attachments";
export const QUEST_LINKS_TAB_ID = "QuestChange-Links";